// App.jsx (complete updated version)
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './Pages/LandingPage';
import Home from './Pages/Home';
import Footer from './components/Footer';
import AdminLogin from './components/AdminControl/AdminLogin';
import AdminDashboard from './components/AdminControl/AdminDashboard';
import AdminPanel from './components/AdminControl/AdminPanel';
import FormSuccess from './components/FormSuccess/FormSuccess'; 
import './App.css';
import { testAPI, submitForm } from './services/apiService'; // ADDED submitForm import

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const savedToken = localStorage.getItem('adminToken');
      const savedUser = localStorage.getItem('adminUser');
      const savedDarkMode = localStorage.getItem('darkMode') === 'true';
      
      console.log('🔐 Auth check on mount:', { 
        hasToken: !!savedToken, 
        hasUser: !!savedUser 
      });
      
      if (savedToken && savedUser) {
        setToken(savedToken);
        try {
          const userData = JSON.parse(savedUser);
          setUser(userData);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Error parsing user data:', error);
          handleLogout();
        }
      }
      
      setDarkMode(savedDarkMode);
      if (savedDarkMode) {
        document.documentElement.classList.add('dark');
      }

      // Test backend connection
      const testConnection = async () => {
        try {
          const response = await fetch('https://kola-lead-capture-server.vercel.app/api/test');
          const data = await response.json();
          console.log('🔗 Backend connection test:', data);
        } catch (error) {
          console.error('❌ Backend connection failed:', error);
        }
      };
    
      testConnection();
    };
    
    checkAuth();
  }, []);

  const handleLoginSuccess = (userData) => {
    console.log('✅ Login successful in App.jsx:', userData);
    setUser(userData);
    const savedToken = localStorage.getItem('adminToken');
    setToken(savedToken);
    setIsAuthenticated(true);
  };

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode.toString());
    
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  const handleLogout = () => {
    console.log('🚪 Logging out...');
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  };

  // ADD THIS FUNCTION TO HANDLE FORM RESET
  const handleFormReset = () => {
    // This will navigate back to the form
    // You can add any additional reset logic here if needed
  };

  // Temporary debug function - call this somewhere in your app
  const testAllEndpoints = async () => {
    console.log('🧪 Testing API endpoints...');
    
    try {
      // Test basic connectivity
      const testResult = await testAPI();
      console.log('✅ /api/test:', testResult);
      
      // Test form submission with sample data (only if authenticated)
      if (isAuthenticated) {
        const sampleFormData = {
          customerName: "Test Customer",
          email: "test@example.com",
          phoneNumber: "1234567890",
          serviceRequired: ["resin driveway"],
          location: "Test City"
        };
        
        const submitResult = await submitForm(sampleFormData);
        console.log('✅ Form submission:', submitResult);
      }
      
    } catch (error) {
      console.error('❌ API test failed:', error);
    }
  };

  // Call this function to test (you can call this from a button or remove if not needed)
  // testAllEndpoints();

  return (
    <Router>
      <div className={`app ${darkMode ? 'dark-theme' : 'light-theme'}`}>
        {/* Only show Navbar when user is logged in */}
        {isAuthenticated && user && (
          <Navbar 
            user={user} 
            onLogout={handleLogout}
            darkMode={darkMode}
            onToggleDarkMode={toggleDarkMode}
          />
        )}
        
        <main className="main-content">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={
              isAuthenticated ? <Navigate to="/" /> : <AdminLogin onLoginSuccess={handleLoginSuccess} />
            } />
            
            {/* Protected Routes - Redirect to login if not authenticated */}
            <Route path="/" element={
              isAuthenticated ? <LandingPage /> : <Navigate to="/login" />
            } />
            <Route path="/form" element={
              isAuthenticated ? <Home /> : <Navigate to="/login" />
            } />
            <Route path="/success" element={ // ADD THIS ROUTE
              isAuthenticated ? <FormSuccess onReset={handleFormReset} /> : <Navigate to="/login" />
            } />
            <Route path="/analytics" element={
              isAuthenticated ? <AdminPanel user={user} /> : <Navigate to="/login" />
            } />
            <Route path="/dashboard" element={
              isAuthenticated ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
            } />
            
            {/* Catch all route - redirect to appropriate page */}
            <Route path="*" element={
              isAuthenticated ? <Navigate to="/" /> : <Navigate to="/login" />
            } />
          </Routes>
        </main>

        {/* Only show Footer when user is logged in */}
        {isAuthenticated && user && <Footer />}
      </div>
    </Router>
  );
}

export default App;